import { pushEvent, pushEventData } from "./utils";
import { isIOS } from "../utilities/globalUtilities";
import { GTM_WEB, GTM_ANDROID, GTM_IOS, GTM_WIN_32, GTM_MAC_INTEL} from "../utilities/constants";

/**
 * Creates the page datalayer
*/
const getPageDataLayer = () => {
    const pageDataLayerContainer = document.querySelector(".page-data-layer");
    
    if (!pageDataLayerContainer) {
        return;
    }
    
    let view = GTM_ANDROID;

    if (isIOS() && navigator.platform != GTM_MAC_INTEL) {
        view = GTM_IOS;
    } else if (navigator.platform == GTM_WIN_32 || navigator.platform == GTM_MAC_INTEL) {
        view = GTM_WEB;
    }

    const pageDataLayerObj = JSON.parse(pageDataLayerContainer?.dataset?.pageDataLayer);
    let pageDataLayer = {
        ...pageDataLayerObj,
        ...(pageDataLayerObj?.event === "initial_data" && pageDataLayerObj?.page_data ? {
            page_data: {
                ...pageDataLayerObj.page_data,
                "view": view
            }
        } : {
            "view": view
        })
    };

    pushEventData(pageDataLayer);

    if (pageDataLayer.event === "initial_data") {
        document.dispatchEvent(new Event("gtmAfterConsent"));
        document.dispatchEvent(new Event("gtmStart"));
    }
};

/**
 * Creates impression after customer activation behavior
*/
const accountValidation = () => {
    const validationContainer = document.querySelector(".gtm-validation-status");

    if (!validationContainer) {
        return;
    }

    const validateAccImpression = Object.assign({}, {
        "message" : validationContainer?.dataset?.gtmValidationStatus,
        "action": "validate",
        "page" : window.location.href
    });

    pushEvent("create_account", validateAccImpression);
};

const initDataLayerEvents = () => {
    getPageDataLayer();

    /**
     * Attaches the global event to newsletter subscription
    */
    document.addEventListener("dataLayer.newsletter", data => {
        const eventData = data?.detail;
        const newsletterImpression = Object.assign({}, {
            "subscriptionMessage" : eventData.subscriptionMessage,
            "subscriptionPage" : window.location.href
        });

        pushEvent("newsletter", newsletterImpression);
    });

    /**
     * Attaches the global event to customer login
    */
    document.addEventListener("dataLayer.login", data => {
        
        const eventData = data?.detail;

        const loginImpression = Object.assign({}, {
            "loginMessage" : eventData?.loginMessage,
            "loginPage" : window.location.href
        });

        pushEvent("login", loginImpression);
    });

    /**
     * Attaches the global event to customer registration
    */
    document.addEventListener("dataLayer.createAccount", data => {
        const eventData = data?.detail;
        const createAccImpression = Object.assign({}, {
            "message" : eventData.message,
            "action": eventData.action,
            "page" : window.location.href
        });

        pushEvent("create_account", createAccImpression);
    });

    /**
     * Attaches the global event to nps, the customer's order grade
    */
    document.addEventListener("dataLayer.NPS", data => {
        const eventData = data?.detail;
        const npsImpression = Object.assign({}, {
            "npsValue" : eventData?.npsValue,
            "transactionId" : eventData?.transactionId
        });

        pushEvent("nps", npsImpression);
    });

    accountValidation();
};

module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
